import React, { useState } from "react";
import VM_table from "./vm_table/VM_table";
import VM_Form from "./vm_Form/VM_Form";


function VM({ onNext, onCancel }) {
  return (
    <section className="Imperiality">
      <div className="imperiality_Form_div">
        <VM_Form onCancel={onCancel} onNext={onNext}/>
      </div>

      <div className="imperiality_table_div">
        <VM_table />
      </div>
    </section>
  );
}

export default VM;
